import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import App from "./App";
import Dashboard from "./pages/Dashboard";
import Landing from "./pages/Landing";
import Chat from "./pages/Chat";
import Link from "./pages/Link";
import Builds from "./pages/Builds";
import Optimizer from "./pages/Optimizer";
import Weapons from "./pages/Weapons";
import Armor from "./pages/Armor";
import Build from "./pages/Build";
import Recommend from "./pages/Recommend";
import Credits from "./pages/Credits";
import Play from "./pages/Play";
import Fireteam from "./pages/Fireteam";
import Diagnostic from "./pages/Diagnostic";
import ThisWeek from "./pages/ThisWeek";
import Loadouts from "./pages/Loadouts";
import Wishlist from "./pages/Wishlist";
import "./styles.css";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<App />}>
          <Route index element={<Landing />} />
          <Route path="app" element={<Dashboard />} />
          <Route path="chat" element={<Chat />} />
          <Route path="link" element={<Link />} />
          <Route path="builds" element={<Builds />} />
          <Route path="optimizer" element={<Optimizer />} />
          <Route path="loadouts" element={<Loadouts />} />
          <Route path="wishlist" element={<Wishlist />} />
          <Route path="weapons" element={<Weapons />} />
          <Route path="armor" element={<Armor />} />
          <Route path="build" element={<Build />} />
          <Route path="recommend" element={<Recommend />} />
          <Route path="play" element={<Play />} />
          <Route path="fireteam" element={<Fireteam />} />
          <Route path="diagnostic" element={<Diagnostic />} />
          <Route path="this-week/:section?" element={<ThisWeek />} />
          <Route path="credits" element={<Credits />} />
        </Route>
      </Routes>
    </BrowserRouter>
  </React.StrictMode>,
);
